var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSentmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_12472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 3.51562V22.4219C40 24.3673 38.4298 25.9375 36.4844 25.9375H3.51562C1.57023 25.9375 0 24.3673 0 22.4219V3.51562C0 2.55477 0.398359 1.68742 1.00781 1.05469H1.03125L19.25 11.4609C19.4845 11.625 19.7423 11.7188 20 11.7188C20.2577 11.7188 20.5155 11.6251 20.75 11.4609L38.9688 1.05469H38.9922C39.6016 1.68742 40 2.55477 40 3.51562Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 3.51562V22.4219C40 24.3673 38.4298 25.9375 36.4844 25.9375H20V11.7188C20.2578 11.7188 20.5155 11.6251 20.75 11.4609L38.9688 1.05469H38.9922C39.6016 1.68742 40 2.55477 40 3.51562Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9688 1.03125V1.05469L20.75 16.1484C20.5155 16.3125 20.2577 16.4062 20 16.4062C19.7423 16.4062 19.4845 16.3126 19.25 16.1484L1.03125 1.05469V1.03125C1.66414 0.398359 2.55477 0 3.51563 0H36.4844C37.4452 0 38.3359 0.398359 38.9688 1.03125Z",
    fill: "#FFDE46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9688 1.03125V1.05469L20.75 16.1484C20.5155 16.3125 20.2577 16.4062 20 16.4062V0H36.4844C37.4452 0 38.3359 0.398359 38.9688 1.03125Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.375 18.9062C23.5626 18.9062 18.8281 23.6407 18.8281 29.4531C18.8281 35.2655 23.5626 40 29.375 40C35.1874 40 40 35.2655 40 29.4531C40 23.6407 35.1874 18.9062 29.375 18.9062Z",
    fill: "#00ABE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 29.4531C40 35.2655 35.1874 40 29.375 40V18.9062C35.1874 18.9062 40 23.6407 40 29.4531Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9609 30.2734L31.3671 33.789C30.9218 34.2577 30.172 34.2577 29.7266 33.789C29.4922 33.5781 29.375 33.2735 29.375 32.9688C29.375 32.6641 29.4922 32.3594 29.7266 32.1485L31.2265 30.625H24.6875C24.0312 30.625 23.5156 30.1095 23.5156 29.4531C23.5156 28.7968 24.0312 28.2813 24.6875 28.2813H31.2265L29.7266 26.7577C29.4922 26.5469 29.375 26.2422 29.375 25.9375C29.375 25.6328 29.4922 25.3281 29.7266 25.1173C30.172 24.6485 30.9218 24.6485 31.3672 25.1173L34.9609 28.6329C35.4297 29.0782 35.4297 29.8281 34.9609 30.2734Z",
    fill: "#F7F0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9609 30.2734L31.3671 33.789C30.9218 34.2577 30.172 34.2577 29.7266 33.789C29.4922 33.5781 29.375 33.2735 29.375 32.9688C29.375 32.6641 29.4922 32.3594 29.7266 32.1485L31.2265 30.625H29.375V28.2813H31.2265L29.7266 26.7577C29.4922 26.5469 29.375 26.2422 29.375 25.9375C29.375 25.6328 29.4922 25.3281 29.7266 25.1173C30.172 24.6485 30.9218 24.6485 31.3672 25.1173L34.9609 28.6329C35.4297 29.0782 35.4297 29.8281 34.9609 30.2734Z",
    fill: "#EFE2DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_12472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSentmailIcon);
export default __webpack_public_path__ + "static/media/TotalSentmailIcon.2fd175536322600cb9503c62de2b8011.svg";
export { ForwardRef as ReactComponent };